import { FC } from "react";
import EmptyValue from "./empty-value";

type Props = { children?: React.ReactNode };

const Value: FC<Props> = ({ children }) => (
  <div className="mt-1 text-sm text-gray-900 break-words">
    {children ?? <EmptyValue />}
  </div>
);

export default Value;
